import { FIELD_TYPES } from '../constants/field-types';
import { requestLogin, requestLogout } from '../fields/bookings-login-bar/login-bar-actions';
import { uploadFile } from '../fields/file-upload/file-upload-actions';
import { loadInitialAppointmentData, getAvailabilityDates, getAvailabilitySlots } from '../services/appointment';
import { fetchServices, loadInitialServicesDropdownData } from '../services/service-dropdown/fetch-services';
export const FIELD_ASYNC_ACTIONS = {
    uploadFile,
    getAvailabilityDates,
    getAvailabilitySlots,
    fetchServices,
    requestLogin,
    requestLogout
};
export const INITIAL_DATA_LOADERS = {
    [FIELD_TYPES.APPOINTMENT]: loadInitialAppointmentData,
    [FIELD_TYPES.SERVICES_DROPDOWN]: loadInitialServicesDropdownData,
    [FIELD_TYPES.SERVICES_MULTI_CHOICE]: loadInitialServicesDropdownData
};

//# sourceMappingURL=controller.js.map